var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8045 30.6177L10.2212 30.6315C7.01285 30.6344 4.38567 28.0124 4.38202 24.804L4.36817 10.2207C4.36525 7.01237 6.98733 4.38518 10.1957 4.38153L24.779 4.36768C27.9873 4.36476 30.6145 6.98685 30.6182 10.1952L30.632 24.7785C30.6357 27.9876 28.0129 30.6148 24.8045 30.6177Z",
    fill: "url(#paint0_radial_320_1580)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8045 30.6177L10.2212 30.6315C7.01285 30.6344 4.38567 28.0124 4.38202 24.804L4.36817 10.2207C4.36525 7.01237 6.98733 4.38518 10.1957 4.38153L24.779 4.36768C27.9873 4.36476 30.6145 6.98685 30.6182 10.1952L30.632 24.7785C30.6357 27.9876 28.0129 30.6148 24.8045 30.6177Z",
    fill: "url(#paint1_radial_320_1580)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 22.6043C14.6858 22.6043 12.3955 20.3147 12.3955 17.5002C12.3955 14.6856 14.6858 12.396 17.4997 12.396C20.3135 12.396 22.6038 14.6856 22.6038 17.5002C22.6038 20.3147 20.3135 22.6043 17.4997 22.6043ZM17.4997 13.8543C15.4894 13.8543 13.8538 15.4899 13.8538 17.5002C13.8538 19.5105 15.4894 21.146 17.4997 21.146C19.51 21.146 21.1455 19.5105 21.1455 17.5002C21.1455 15.4899 19.51 13.8543 17.4997 13.8543Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 13.125C23.5728 13.125 24.0625 12.6353 24.0625 12.0312C24.0625 11.4272 23.5728 10.9375 22.9688 10.9375C22.3647 10.9375 21.875 11.4272 21.875 12.0312C21.875 12.6353 22.3647 13.125 22.9688 13.125Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8747 26.9793H13.1247C10.3108 26.9793 8.02051 24.6897 8.02051 21.8752V13.1252C8.02051 10.3106 10.3108 8.021 13.1247 8.021H21.8747C24.6885 8.021 26.9788 10.3106 26.9788 13.1252V21.8752C26.9788 24.6897 24.6885 26.9793 21.8747 26.9793ZM13.1247 9.47933C11.1144 9.47933 9.47884 11.1149 9.47884 13.1252V21.8752C9.47884 23.8855 11.1144 25.521 13.1247 25.521H21.8747C23.885 25.521 25.5205 23.8855 25.5205 21.8752V13.1252C25.5205 11.1149 23.885 9.47933 21.8747 9.47933H13.1247Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_320_1580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1317 30.6505) scale(32.7389 32.7389)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_320_1580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.59442 4.03977) scale(21.7386 14.4845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.ca5bd275ed8034446818b34d767538de.svg";
export { ForwardRef as ReactComponent };